// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1644555520790
      var cssReload = require("C:/Users/dell/Downloads/HBuilderX.3.2.16.20211122.full/HBuilderX/plugins/uniapp-cli/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  